import React from 'react';
import { Button } from 'primereact/button';
import useMyVehicleStock from './hooks/useMyVehicleStock';
import VehicleStockFilter from './components/VehicleStockFilter';
import VehicleStockTable from './components/VehicleStockTable';

const MyVehicleStockPage = () => {
    const { th, data, isLoading, filters, handleApplyFilters, handleResetFilters, refetch } = useMyVehicleStock();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{th('vehicleSalesMyVehicleStock.pageTitle')}</h3>
                <Button
                    icon="pi pi-refresh"
                    label={th('vehicleSalesMyVehicleStock.buttons.refresh')}
                    onClick={refetch}
                />
            </div>

            <VehicleStockFilter
                filters={filters}
                onApplyFilters={handleApplyFilters}
                onReset={handleResetFilters}
            />

            <VehicleStockTable data={data} loading={isLoading} onRefetch={refetch} />
        </div>
    );
};

export default MyVehicleStockPage;
